"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "zafferana-etnea": {
    "7236c85e": [{
      "hkey": "4b0a9d7d",
      "slug": "zafferana-etnea",
      "name": "Zafferana Etnea",
      "primary": true,
      "skipSearch": false
    }],
    "airone-emmaus": [{
      "hkey": "4b0a9d7d",
      "slug": "zafferana-etnea",
      "name": "Zafferana Etnea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "305694f9": [{
      "hkey": "4b0a9d7d",
      "slug": "zafferana-etnea",
      "name": "Zafferana Etnea",
      "primary": true,
      "skipSearch": false
    }],
    "caselle": [{
      "hkey": "4b0a9d7d",
      "slug": "zafferana-etnea",
      "name": "Zafferana Etnea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "21660d60": [{
      "hkey": "4b0a9d7d",
      "slug": "zafferana-etnea",
      "name": "Zafferana Etnea",
      "primary": true,
      "skipSearch": false
    }],
    "fleri": [{
      "hkey": "4b0a9d7d",
      "slug": "zafferana-etnea",
      "name": "Zafferana Etnea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0f5610b6": [{
      "hkey": "4b0a9d7d",
      "slug": "zafferana-etnea",
      "name": "Zafferana Etnea",
      "primary": true,
      "skipSearch": false
    }],
    "passopomo": [{
      "hkey": "4b0a9d7d",
      "slug": "zafferana-etnea",
      "name": "Zafferana Etnea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a723eb1c": [{
      "hkey": "4b0a9d7d",
      "slug": "zafferana-etnea",
      "name": "Zafferana Etnea",
      "primary": true,
      "skipSearch": false
    }],
    "petrulli": [{
      "hkey": "4b0a9d7d",
      "slug": "zafferana-etnea",
      "name": "Zafferana Etnea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c4e1af42": [{
      "hkey": "4b0a9d7d",
      "slug": "zafferana-etnea",
      "name": "Zafferana Etnea",
      "primary": true,
      "skipSearch": false
    }],
    "pisano": [{
      "hkey": "4b0a9d7d",
      "slug": "zafferana-etnea",
      "name": "Zafferana Etnea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "98d0e312": [{
      "hkey": "4b0a9d7d",
      "slug": "zafferana-etnea",
      "name": "Zafferana Etnea",
      "primary": true,
      "skipSearch": false
    }],
    "poggiofelice": [{
      "hkey": "4b0a9d7d",
      "slug": "zafferana-etnea",
      "name": "Zafferana Etnea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;